//@ts-nocheck
import { LinkProps } from 'react-router-dom';
import * as React from 'react';
import { Button, Classes, Divider, Icon, Link, NavbarButton } from '../index';
import { faOdepnoutIcon, faPripnoutIcon } from './NavBarMenuIcons';
import classNames from 'classnames';
import { Fragment } from 'react';

//Již deprecated, nahrazeno parametrem separator v DefaultMenuItemProps
export const NAVMENU_SEPARATOR = { key: 'SEPARATOR' };

export type AppMenuProps = {
  /*
   *Jednotlivé položky navbar menu.
   */
  menuItems: MenuItemProps[];
  onClick?: (
    item: MenuItemProps,
    key: string,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => any;
  /*
   *Šířka panelu v pixelech, defaultně 270px.
   */
  panelWidth?: number;
  /*
   *Key aktuální položky menu, slouží k vyznačení položky.
   */
  currentKey?: string;
  style?: React.HTMLAttributes<HTMLDivElement>['style'];
  scrollWrapStyle?: React.HTMLAttributes<HTMLDivElement>['style'];
};
type DefaultMenuItemProps = {
  /*
   *Label itemu
   */
  label?: string;
  /**
   * Ikona renderovaná vedle labelu.
   */
  iconRight?: React.JSX.Element;
  /*
   *Klíč itemu, použitý pro identifikaci itemu při onClick
   */
  key: string;
  /*
   *Pokud je vyplněn, bude item fungovat jako odkaz
   */
  link?: LinkProps;
  /*
   *Pokud je true, bude item sloužit jako oddělovač a pokud je zároveň vyplněn link tak bude link ignorován
   */
  separator?: boolean;
};
export type MenuItemProps = DefaultMenuItemProps & {
  /*
   *Zanoření itemů, až do 3. úrovně
   */
  children?: MenuItemProps[];
};
type FlatNavBarMenuItemProps = DefaultMenuItemProps & {
  level: number;
};
const flatItems = (
  item: MenuItemProps,
  flattedArray: FlatNavBarMenuItemProps[],
  level: number = 0
) => {
  level++;
  if (item.children) {
    const { children, ...rest } = item;
    flattedArray.push({ ...rest, level });
    children.forEach((child) => {
      flatItems(child, flattedArray, level);
    });
  } else {
    flattedArray.push({ ...item, level });
  }
};
export const NavMenu: React.FC<AppMenuProps> = ({
  menuItems,
  onClick,
  currentKey,
  style,
  scrollWrapStyle,
}) => {
  const flattedItems = React.useMemo(() => {
    const flattedArray: FlatNavBarMenuItemProps[] = [];
    menuItems?.forEach((item) => {
      flatItems(item, flattedArray);
    });
    return flattedArray;
  }, [menuItems]);

  return (
    <div
      className={classNames(
        Classes.NAVBAR_MENU_CONTENT,
        Classes.INVERSE_SCROLL_CONTAINER
      )}
      style={scrollWrapStyle}
    >
      {flattedItems.length > 0 && (
        <div
          id={'nav-menu-item-container'}
          className={[Classes.NAVBAR_MENU_ITEM_CONTAINER]}
          style={style}
        >
          <div className={[Classes.NAVBAR_MENU_SCROLL_CONTAINER]}>
            {flattedItems.map((item, index) => {
              const current = item.key === currentKey;
              if (item.key === 'SEPARATOR' || item.separator) {
                if (!item.label) {
                  return (
                    <Fragment key={index}>
                      <Divider
                        className={Classes.NAVBAR_MENU_SEPARATOR}
                        horizontal
                      />
                    </Fragment>
                  );
                } else {
                  return (
                    <Fragment key={index}>
                      <div
                        onClick={
                          onClick
                            ? (event) => onClick(item, item.key, event)
                            : undefined
                        }
                        className={Classes.NAVBAR_MENU_ITEM_SEPARATOR}
                        key={item.key}
                      >
                        <span>{item.label}</span>
                      </div>
                    </Fragment>
                  );
                }
              }

              return (
                <Fragment key={index}>
                  {item.link ? (
                    <Link
                      style={{ textDecoration: 'none' }}
                      {...item.link}
                      className={'w-100'}
                    >
                      <div
                        className={classNames(
                          `level-${item.level} ` + Classes.NAVBAR_MENU_ITEM,
                          { [Classes.NAVBAR_MENU_ITEM_CURRENT]: current }
                        )}
                      >
                        {item.label}
                        {item.iconRight ?? null}
                      </div>
                    </Link>
                  ) : (
                    <div
                      onClick={
                        onClick
                          ? (event) => onClick(item, item.key, event)
                          : undefined
                      }
                      className={classNames(
                        `level-${item.level} ` + Classes.NAVBAR_MENU_ITEM,
                        { [Classes.NAVBAR_MENU_ITEM_CURRENT]: current }
                      )}
                      key={item.key}
                    >
                      <span>{item.label}</span>
                      {item.iconRight ?? null}
                    </div>
                  )}
                </Fragment>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
